<template>
  <v-container class="pa-1" fluid>
    <v-form ref="form">
      <v-row>
        <v-col cols="12">
          <v-card :key="index" style="margin-bottom: 15px;" v-for="(item, index) in delegation.transport">
            <v-card-title class="grey lighten-5 py-2" :class="{ 'py-2': $store.state.Delegation.readonly === true }">
              <h5>{{ $t("delegation.form.transportFragment") }} {{ index + 1 }}</h5>
              <v-spacer />
              <v-tooltip top v-if="$store.state.Delegation.readonly !== true">
                {{ $t("delegation.form.duplicateThisTransportFragment") }}
                <template #activator="{on}">
                  <v-btn icon v-on="on" @click="duplicateTransport(item)">
                    <v-icon>fa-copy</v-icon>
                  </v-btn>
                </template>
              </v-tooltip>
              <v-tooltip top v-if="$store.state.Delegation.readonly !== true">
                {{ $t("delegation.form.removeThisTransportFragment") }}
                <template #activator="{on}">
                  <v-btn icon v-on="on" @click="removeTransport(item)">
                    <v-icon>close</v-icon>
                  </v-btn>
                </template>
              </v-tooltip>
            </v-card-title>
            <v-card-text>
              <first-row
                :model-amount-validation="delegationErrors.transport[index].amount_in_currency"
                :model-amount.sync="item.amount_in_currency"
                :model-booking-id-validation="delegationErrors.transport[index].booking_id"
                :model-booking-id.sync="item.booking_id"
                :model-booking-ticket.sync="item.booking_ticket"
                :model-currency-validation="delegationErrors.transport[index].currency"
                :model-currency.sync="item.currency"
                :model-file-id-validation="delegationErrors.transport[index].file_id"
                :model-file-id.sync="item.file_id"
                :model-settlement-type-id-validation="delegationErrors.transport[index].settlement_type_id"
                :model-settlement-type-id.sync="item.settlement_type_id"
                :model-transport-type-validation="delegationErrors.transport[index].transport_type"
                :model-transport-type.sync="item.transport_type"
                :model-vehicle-id-validation="delegationErrors.transport[index].vehicle_id"
                :model-vehicle-id.sync="item.vehicle_id"
                v-on:importRailRoute="
                  bookingItem => {
                    importRailRoute(item, bookingItem);
                  }
                "
                v-on:importRouteBack="
                  bookingItem => {
                    importRouteBack(item, bookingItem);
                  }
                "
                v-on:importRouteTo="
                  bookingItem => {
                    importRouteTo(item, bookingItem);
                  }
                "
                :model-comment.sync="item.comment"
                :model-comment-validation="delegationErrors.transport[index].comment"
              >
              </first-row>
              <v-row dense>
                <v-col md="3" sm="6" cols="12">
                  <location-ajax-select
                    :placeholder.sync="item.from_place_text"
                    :select-model.sync="item.from_place_id"
                    :select-text.sync="item.from_place_text"
                    :label="$t('delegation.form.fields.transport.startPlace.name')"
                    v-bind:select-validation="delegationErrors.transport[index].from_place_id"
                    :defaultItems="startLocationDefaultItems(item)"
                    v-on:update:selectModel="recalculateGoogleMapsDistance(item)"
                    :readonly="$store.state.Delegation.readonly === true"
                  />
                </v-col>
                <v-col md="3" sm="6" cols="12">
                  <date-time-picker-computed
                    :date-time-validation="delegationErrors.transport[index].start_date"
                    :default-button="true"
                    :default-value="startDateDefaultValue(item)"
                    :label="$t('delegation.form.fields.transport.startDate.name')"
                    v-bind:dateTimeModel.sync="item.start_date"
                    :readonly="$store.state.Delegation.readonly === true"
                  />
                </v-col>
                <v-col md="3" sm="6" cols="12">
                  <location-ajax-select
                    :placeholder="item.to_place_text"
                    :select-text.sync="item.to_place_text"
                    :select-model.sync="item.to_place_id"
                    :label="$t('delegation.form.fields.transport.endPlace.name')"
                    :select-validation="delegationErrors.transport[index].to_place_id"
                    :defaultItems="endLocationDefaultItems(item)"
                    v-on:update:selectModel="recalculateGoogleMapsDistance(item)"
                    :readonly="$store.state.Delegation.readonly === true"
                  />
                </v-col>
                <v-col md="3" sm="6" cols="12">
                  <date-time-picker-computed
                    :date-time-validation="delegationErrors.transport[index].end_date"
                    :default-button="true"
                    :default-value="endDateDefaultValue(item)"
                    :label="$t('delegation.form.fields.transport.endDate.name')"
                    :dateTimeModel.sync="item.end_date"
                    :readonly="$store.state.Delegation.readonly === true"
                  />
                </v-col>
              </v-row>
              <v-row dense v-if="item.transport_type === transportType.TRANSPORT_CAR_RENTAL || item.transport_type === transportType.TRANSPORT_CAR">
                <v-col sm="3" cols="6">
                  <v-text-field
                    :error-messages="delegationErrors.transport[index].distance"
                    :label="$t('delegation.form.fields.transport.distance.name')"
                    v-model="item.distance"
                    :readonly="$store.state.Delegation.readonly === true"
                  />
                </v-col>
                <v-col sm="3" cols="6">
                  <v-text-field disabled :label="$t('delegation.form.fields.transport.googleMapsDistance.name')" v-model="item.google_maps_api_distance">
                  </v-text-field>
                </v-col>
                <v-col sm="6" cols="12">
                  <v-text-field
                    :error-messages="delegationErrors.transport[index].comment"
                    :label="$t('delegation.form.fields.transport.comment.name')"
                    v-model="item.comment"
                    :readonly="$store.state.Delegation.readonly === true"
                  />
                </v-col>
              </v-row>
              <v-row v-if="item.transport_type === transportType.TRANSPORT_CAR_RENTAL">
                <v-col sm="3" cols="6">
                  <text-field-with-copy-default-button
                    :label="$t('delegation.form.fields.transport.carRentalName.name')"
                    :model.sync="item.car_rental_name"
                    :error-messages="delegationErrors.transport[index].car_rental_name"
                    :default-button="true"
                    :default-value="$store.getters['Delegation/lastCarRentalName']"
                    :readonly="$store.state.Delegation.readonly === true"
                  />
                </v-col>
                <v-col sm="3" cols="6">
                  <text-field-with-copy-default-button
                    :label="$t('delegation.form.fields.transport.carRentalVehicleName.name')"
                    :model.sync="item.car_rental_vehicle_name"
                    :error-messages="delegationErrors.transport[index].car_rental_vehicle_name"
                    :default-button="true"
                    :default-value="$store.getters['Delegation/lastCarRentalVehicleName']"
                    :readonly="$store.state.Delegation.readonly === true"
                  />
                </v-col>
                <v-col sm="6" cols="12">
                  <text-field-with-copy-default-button
                    :label="$t('delegation.form.fields.transport.carRentalVehicleModel.name')"
                    :model.sync="item.car_rental_vehicle_model"
                    :error-messages="delegationErrors.transport[index].car_rental_vehicle_model"
                    :default-button="true"
                    :default-value="$store.getters['Delegation/lastCarRentalVehicleModel']"
                    :readonly="$store.state.Delegation.readonly === true"
                  />
                </v-col>
              </v-row>
              <v-row v-if="item.transport_type === transportType.TRANSPORT_OTHER && item.settlement_type_id !== 7">
                <v-col sm="12" cols="12">
                  <v-text-field
                    :error-messages="delegationErrors.transport[index].comment"
                    :label="$t('delegation.form.fields.transport.comment.name')"
                    v-model="item.comment"
                    :readonly="$store.state.Delegation.readonly === true"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" v-if="$store.state.Delegation.readonly !== true">
          <v-btn color="accent" v-on:click="addTransport">{{ $t("global.add") }}</v-btn>
        </v-col>

        <v-col cols="12">
          <collapse-other-transport-panel
            :model-other.sync="delegation.other"
            :readonly="$store.state.Delegation.readonly === true"
            :clearable="$store.state.Delegation.readonly !== true"
          />
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import { transportType } from "../../../staticData/TransportTypes";
import TransportTypes from "../../../staticData/TransportTypes";
import LocationAjaxSelect from "../../CustomInputComponents/LocationAjaxSelect.vue";
import DateTimePickerComputed from "../../CustomInputComponents/DateTimePickerComputed.vue";
import FirstRow from "./transport/FirstRow.vue";
import createErrorArray from "../../../repository/errorObjectArray";
import CollapseOtherTransportPanel from "./other/CollapseOtherTransportPanel.vue";
import TextFieldWithCopyDefaultButton from "../../CustomInputComponents/TextFieldWithCopyDefaultButton";

export default {
  name: "Transport",
  components: {
    TextFieldWithCopyDefaultButton,
    CollapseOtherTransportPanel,
    FirstRow,
    LocationAjaxSelect,
    DateTimePickerComputed
  },
  props: {
    delegation: {
      type: Object,
      required: true
    },
    delegationErrors: {
      type: Object,
      required: false,
      default: function() {
        return createErrorArray(this.delegation);
      }
    }
  },
  data: () => ({
    formControls: {
      additionalCostsShow: false
    },
    additionalCost: [],
    vehicles: [],
    transportType
  }),
  computed: {
    transportTypes: TransportTypes
  },
  methods: {
    addTransport() {
      this.$store.dispatch("Delegation/addTransport");
    },
    removeTransport(item) {
      this.$store.dispatch("Delegation/removeTransport", item);
    },
    duplicateTransport(item) {
      this.$store.dispatch("Delegation/duplicateTransport", item);
    },
    recalculateGoogleMapsDistance(item) {
      this.$nextTick(function() {
        if (item.to_place_id != null && item.from_place_id != null && item.to_place_id.length > 0 && item.from_place_id.length > 0) {
          this.axios
            .post("location/get-distance-by-google-maps", {
              to_place_id: item.to_place_id,
              from_place_id: item.from_place_id
            })
            .then(resp => {
              item.google_maps_api_distance = Math.round(resp.data.distance / 1000);
            });
        }
      });
      //
    },
    importRouteTo(transportItem, bookingItem) {
      transportItem.from_place_id = bookingItem.flightAttributes.start_airport_place_id;
      transportItem.start_date = bookingItem.flightAttributes.start_date + " " + bookingItem.flightAttributes.start_time.slice(0, 5);
      transportItem.from_place_text = bookingItem.flightAttributes.start_airport_place_name;
      transportItem.to_place_text = bookingItem.flightAttributes.end_airport_place_name;
      transportItem.to_place_id = bookingItem.flightAttributes.end_airport_place_id;
      transportItem.end_date = bookingItem.flightAttributes.end_date + " " + bookingItem.flightAttributes.end_time.slice(0, 5);
    },
    importRouteBack(transportItem, bookingItem) {
      transportItem.from_place_text = bookingItem.flightAttributes.return_start_airport_place_name;
      transportItem.from_place_id = bookingItem.flightAttributes.return_start_airport_place_id;
      transportItem.start_date = bookingItem.flightAttributes.return_start_date + " " + bookingItem.flightAttributes.return_start_time.slice(0, 5);
      transportItem.to_place_id = bookingItem.flightAttributes.return_end_airport_place_id;
      transportItem.end_date = bookingItem.flightAttributes.return_end_date + " " + bookingItem.flightAttributes.return_end_time.slice(0, 5);
      transportItem.to_place_text = bookingItem.flightAttributes.return_end_airport_place_name;
    },
    importRailRoute(transportItem, bookingItem) {
      transportItem.start_date =
        bookingItem.railAttributes.start_time == null
          ? bookingItem.railAttributes.start_date
          : bookingItem.railAttributes.start_date + " " + bookingItem.railAttributes.start_time.slice(0, 5);
      transportItem.end_date =
        bookingItem.railAttributes.start_time == null
          ? bookingItem.railAttributes.end_date
          : bookingItem.railAttributes.end_date + " " + bookingItem.railAttributes.end_time.slice(0, 5);
      if (bookingItem.railAttributes.start_place_id != null) {
        transportItem.from_place_id = bookingItem.railAttributes.start_place_id;
        transportItem.from_place_text = bookingItem.railAttributes.start_place_name;
      }
      if (bookingItem.railAttributes.end_place_id != null) {
        transportItem.to_place_id = bookingItem.railAttributes.end_place_id;
        transportItem.to_place_text = bookingItem.railAttributes.end_place_name;
      }
    },
    startDateDefaultValue(transportItem) {
      let indexOfItem = this.delegation.transport.indexOf(transportItem);
      if (indexOfItem === 0) {
        return this.delegation.start_date;
      }
      return this.delegation.transport[indexOfItem - 1].end_date;
    },
    endDateDefaultValue(transportItem) {
      let indexOfItem = this.delegation.transport.indexOf(transportItem);
      if (indexOfItem === this.delegation.transport.length - 1) {
        return this.delegation.end_date;
      }
      return this.delegation.transport[indexOfItem + 1].start_date;
    },
    startLocationDefaultItems(transportItem) {
      let indexOfItem = this.delegation.transport.indexOf(transportItem);
      if (indexOfItem === 0) {
        let userData = this.$store.state.Delegation.delegationAvailableUsers.find(value => value.id.toString() === this.delegation.user_id);
        let result = [];
        if (typeof userData != "undefined" && userData.workLocationId !== null) {
          result.push({
            value: userData.workLocationId,
            text: this.$t("global.workLocation") + ": " + userData.workLocationText
          });
        }
        if (typeof userData != "undefined" && userData.homeLocationId !== null) {
          result.push({
            value: userData.homeLocationId,
            text: this.$t("global.homeLocation") + ": " + userData.homeLocationText
          });
        }
        return result;
      }
      if (this.delegation.transport[indexOfItem - 1].to_place_id != null && this.delegation.transport[indexOfItem - 1].to_place_id.length > 1) {
        return [
          {
            value: this.delegation.transport[indexOfItem - 1].to_place_id,
            text: this.delegation.transport[indexOfItem - 1].to_place_text
          }
        ];
      }
      return [];
    },
    endLocationDefaultItems(transportItem) {
      let indexOfItem = this.delegation.transport.indexOf(transportItem);
      if (indexOfItem === this.delegation.transport.length - 1) {
        let userData = this.$store.state.Delegation.delegationAvailableUsers.find(value => value.id.toString() === this.delegation.user_id);
        let result = [];
        if (typeof userData != "undefined" && userData.workLocationId !== null) {
          result.push({
            value: userData.workLocationId,
            text: this.$t("global.workLocation") + ": " + userData.workLocationText
          });
        }
        if (typeof userData != "undefined" && userData.homeLocationId !== null) {
          result.push({
            value: userData.homeLocationId,
            text: this.$t("global.homeLocation") + ": " + userData.homeLocationText
          });
        }
        return result;
      }
      if (this.delegation.transport[indexOfItem + 1].from_place_id != null && this.delegation.transport[indexOfItem + 1].from_place_id.length > 1) {
        return [
          {
            value: this.delegation.transport[indexOfItem + 1].from_place_id,
            text: this.delegation.transport[indexOfItem + 1].from_place_text
          }
        ];
      }
      return [];
    }
  }
};
</script>

<style scoped></style>
